import { Theme, ThemeUICSSObject } from 'theme-ui';
import { common } from './common';
import { util } from './util';
import { charts } from './charts';
import { validations } from './validations';
import templates from './templates';
/* IMPORT HERE */

export const layout: (theme: Theme) => Record<string, ThemeUICSSObject> = (
  theme,
) => {
  return {
    charts,
    common: common(theme),
    util,
    ...templates,
    validations,
    /* PREPEND HERE */
  };
};
